import { useUserStore } from '../../store/useUserStore';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Url from '../../data/url';
import { useKidDetailQuery } from '../../queries';
import { BOTTOM_NAVI, WELCOME_SKIPPED_KEY } from '../../data/define';
import FullHeightContainer from '../../component/common/FullHeightContainer';
import BottomNavigationV2 from '../../component/common/BottomNavigationV2';
import Header from '../../component/home/Header';
import AIAnalytics from '../../component/home/AIAnalytics';
import MoreInfo from '../../component/home/MoreInfo';
import { Report } from '../../types';

function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useUserStore();
  const [analysisToggleOpen, setAnalysisToggleOpen] = useState(false);

  const { data: kidDetail } = useKidDetailQuery(user?.mainKid?.id, {
    enabled: user?.isLoggedIn && !!user?.mainKid?.id,
  });
  const reports: Report[] = kidDetail?.reports || [];

  useEffect(() => {
    // welcome 페이지에서는 이 로직을 실행하지 않음
    if (location.pathname === Url.LoginWelcome) {
      return;
    }
    const isWelcomeSkipped = localStorage.getItem(WELCOME_SKIPPED_KEY);
    if (user?.isSignup && user?.kids?.length === 0 && isWelcomeSkipped !== 'true') {
      navigate(Url.KidsRegister);
      return;
    }
  }, [user, navigate, location.pathname]);

  return (
    <FullHeightContainer>
      <div className="pageInner" style={{ paddingBottom: '100px' }}>
        <Header reports={reports} setAnalysisToggleOpen={setAnalysisToggleOpen} />
        {/* <button
          onClick={() => {
            throw new Error(`에러 테스트 ${new Date().getTime()}`);
          }}
        >
          에러버튼
        </button> */}
        <AIAnalytics reports={reports} />
        <MoreInfo />
      </div>
      <BottomNavigationV2
        focusTab={BOTTOM_NAVI.HOME}
        isOpenToggleBtn={analysisToggleOpen}
        setIsOpenToggleBtn={setAnalysisToggleOpen}
      />
    </FullHeightContainer>
  );
}

export default HomePage;
